export default (props, traits) => {
  const { rhythm } = traits

  return {
    content: {
      marginBottom: rhythm(1)
    }
  }
}
